import { I18nLocale } from '#/i18n/types/I18nLocale';

export const LOCALE_NAMES = {
  [I18nLocale.EN]: 'English',
  [I18nLocale.ES]: 'Español',
  [I18nLocale.PT]: 'Português',
};

export const LOCALE_RADIO_OR_SELECT_OPTIONS = () =>
  Object.entries(LOCALE_NAMES).map(([key, value]) => ({
    value: key as keyof typeof LOCALE_NAMES,
    label: value,
  }));

export const LISTING_LOCALE_RADIO_OPTIONS = () => [
  { value: I18nLocale.EN, label: LOCALE_NAMES[I18nLocale.EN] },
  { value: I18nLocale.ES, label: LOCALE_NAMES[I18nLocale.ES] },
];

export const ORG_LOCALE_RADIO_OPTIONS = () => [
  { value: I18nLocale.EN, label: LOCALE_NAMES[I18nLocale.EN] },
  { value: I18nLocale.ES, label: LOCALE_NAMES[I18nLocale.ES] },
];

export const USER_LOCALE_RADIO_OR_SELECT_OPTIONS = () => [
  { value: I18nLocale.EN, label: LOCALE_NAMES[I18nLocale.EN] },
  { value: I18nLocale.ES, label: LOCALE_NAMES[I18nLocale.ES] },
];

export const STAFF_LOCALE_RADIO_OR_SELECT_OPTIONS = () => [
  { value: I18nLocale.EN, label: LOCALE_NAMES[I18nLocale.EN] },
  { value: I18nLocale.ES, label: LOCALE_NAMES[I18nLocale.ES] },
];

export const LOCALE_CHECKBOX_OPTIONS = () =>
  Object.entries(LOCALE_NAMES).map(([key, value]) => ({
    name: key as keyof typeof LOCALE_NAMES,
    label: value,
  }));

export const SEARCH_LOCALE_CHECKBOX_OPTIONS = () => [
  { name: I18nLocale.EN, label: LOCALE_NAMES[I18nLocale.EN] },
  { name: I18nLocale.ES, label: LOCALE_NAMES[I18nLocale.ES] },
];

export const LOCALE_WITH_ALL = {
  ...LOCALE_NAMES,
  all: 'All',
};

export const LOCALE_WITH_ALL_RADIO_OR_SELECT_OPTIONS = () =>
  Object.entries(LOCALE_WITH_ALL).map(([key, value]) => ({
    value: key as keyof typeof LOCALE_WITH_ALL,
    label: value,
  }));

export const STAFF_LOCALE_WITH_ALL_RADIO_OR_SELECT_OPTIONS = () => [
  { value: I18nLocale.EN, label: LOCALE_NAMES[I18nLocale.EN] },
  { value: I18nLocale.ES, label: LOCALE_NAMES[I18nLocale.ES] },
  { value: 'all' as const, label: LOCALE_WITH_ALL.all },
];

export const LOCALE_WITH_ALL_CHECKBOX_OPTIONS = () =>
  Object.entries(LOCALE_WITH_ALL).map(([key, value]) => ({
    name: key as keyof typeof LOCALE_WITH_ALL,
    label: value,
  }));
